// extracted by mini-css-extract-plugin
module.exports = {"padding-top-12px":"style_padding-top-12px__1JhYN","align-text-center":"style_align-text-center__1vXKM"};